import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useAuth } from '../AuthContext';

// Use the same mockPosts as Blog.js for now
const mockPosts = [
  {
    id: 1,
    title: 'Welcome to Our Blog!',
    excerpt: 'Discover the latest updates, tips, and news from our team.',
    content: 'Full content for Welcome to Our Blog! ...',
    author: 'Admin',
    created_at: '2024-06-01T10:00:00Z',
  },
  {
    id: 2,
    title: 'How to Get the Most from Our Service',
    excerpt: 'Maximize your experience with these expert tips.',
    content: 'Full content for How to Get the Most from Our Service ...',
    author: 'Jane Smith',
    created_at: '2024-06-02T14:30:00Z',
  },
];

const BlogEditor = () => {
  const { user } = useAuth();
  const [role, setRole] = useState('admin'); // Set to 'admin' for mockup; replace with real role check
  const navigate = useNavigate();
  const { id } = useParams();
  const editing = Boolean(id);

  // Prefill fields if editing
  const postToEdit = editing ? mockPosts.find((p) => p.id === Number(id)) : null;
  const [title, setTitle] = useState(postToEdit ? postToEdit.title : '');
  const [content, setContent] = useState(postToEdit ? postToEdit.content : '');
  const [excerpt, setExcerpt] = useState(postToEdit ? postToEdit.excerpt : '');

  if (!user || role !== 'admin') {
    return <div className="max-w-2xl mx-auto mt-10 p-6 bg-white rounded-xl shadow-soft text-center">Access Denied: Admins only.</div>;
  }

  const handleSave = (e) => {
    e.preventDefault();
    // Placeholder: Save logic here (connect to Supabase later)
    alert(editing ? 'Post updated (mock)' : 'Post created (mock)');
    navigate('/blog');
  };

  return (
    <div className="max-w-2xl mx-auto mt-10 p-6 bg-white rounded-xl shadow-soft">
      <h2 className="text-2xl font-bold mb-4">{editing ? 'Edit Post' : 'New Post'}</h2>
      <form onSubmit={handleSave} className="flex flex-col gap-4">
        <input
          type="text"
          placeholder="Title"
          value={title}
          onChange={e => setTitle(e.target.value)}
          required
          className="border rounded px-3 py-2"
        />
        <textarea
          placeholder="Excerpt"
          value={excerpt}
          onChange={e => setExcerpt(e.target.value)}
          required
          className="border rounded px-3 py-2"
        />
        <textarea
          placeholder="Content"
          value={content}
          onChange={e => setContent(e.target.value)}
          required
          rows={8}
          className="border rounded px-3 py-2"
        />
        <div className="flex gap-2 mt-2">
          <button type="submit" className="bg-accent text-white px-4 py-2 rounded font-semibold hover:bg-primary transition">
            Save
          </button>
          <button type="button" onClick={() => navigate('/blog')} className="bg-gray-300 text-gray-700 px-4 py-2 rounded font-semibold hover:bg-gray-400 transition">
            Cancel
          </button>
        </div>
      </form>
    </div>
  );
};

export default BlogEditor; 